import { POUNDS_PER_GRAM, POUNDS_PER_KILOGRAM, POUNDS_PER_OUNCE } from '@/shared/dictionaries/unitConversion.dictionary'

export const convertToPounds = function (weight: string, weightUnit: string): number {
  const value = parseFloat(weight)
  const unit = weightUnit.toLowerCase()

  switch (unit) {
    case 'oz':
    case 'ounce':
    case 'ounces':
      return value * POUNDS_PER_OUNCE

    case 'kg':
    case 'kgs':
    case 'kilogram':
    case 'kilograms':
      return value * POUNDS_PER_KILOGRAM

    case 'g':
    case 'gram':
    case 'grams':
      return value * POUNDS_PER_GRAM

    case 'lb':
    case 'lbs':
    case 'pound':
    case 'pounds':
    default:
      return value
  }
}
